/**
 * Colors_T45.jsx
 * Identity for B2C Template 45 — "Epic Navy" Theme
 * Deep Navy / Warm Gold / Ivory palette. Premium, editorial, boutique-agency feel.
 */
import { getAssetUrl } from '../../Common/Utils/assetUrl';
export const mapB2CTenantToLanding = (tenantData) => {
  return {
      isPreview: tenantData?.isPreview ?? false,
    companyId:       tenantData?.companyId,
    logoUrl:         getAssetUrl(tenantData?.branding?.logoUrl) || '/assets/images/logo.png',
    brandName:       tenantData?.branding?.brandName    || 'Horizon Travels',
    email:           tenantData?.branding?.email        || 'support@horizontravels.com',

    phones:          Array.isArray(tenantData?.branding?.phones)
                     ? tenantData?.branding?.phones[0]
                     : tenantData?.branding?.phones || '9177656344',

    whatsapp:        tenantData?.branding?.whatsapp     || '9177656344',
    socials:         tenantData?.branding?.socials      || {},
     companyData:     tenantData?.companyData || {},
     seo: tenantData?.seo || {},

    themeColor1:     tenantData?.theme?.themeColor1,
    themeColor2:     tenantData?.theme?.themeColor2,
    themeColor3:     tenantData?.theme?.themeColor3,
    themeColor4:     tenantData?.theme?.themeColor4,
    themeColor5:     tenantData?.theme?.themeColor5,

    headerBgOverride:   tenantData?.header?.bgColor,
    headerTextOverride: tenantData?.header?.textColor,
    footerBgOverride:   tenantData?.footer?.bgColor,
    footerTextOverride: tenantData?.footer?.textColor,

    headerMenu:      tenantData?.header,
    footerAboutText: tenantData?.footer?.aboutText,
    footerCopyright: tenantData?.footer?.copyright,

    heroData:        tenantData?.hero,
    aboutUs:         tenantData?.aboutUs,
    contactUs:       tenantData?.contactUs,
    destinations:    tenantData?.destinations,
    activeModules:   tenantData?.activeModules,

    metaTitle:       tenantData?.seo?.metaTitle,
    metaDescription: tenantData?.seo?.metaDescription,
  };
};

export const getB2CColors_T45 = (landingData) => {
  const gold    = landingData?.themeColor1 || '#C9A15F';  // Warm Gold — primary accent / CTA
  const navy    = landingData?.themeColor2 || '#14283F';  // Deep Navy — dark elements, headings
  const surface = landingData?.themeColor3 || '#FFFFFF';  // Pure White — panels/cards
  const slate   = landingData?.themeColor4 || '#4C6B8A';  // Muted Slate Blue — secondary accent
  const ivory   = landingData?.themeColor5 || '#FAF6EF';  // Warm Ivory — page background

  return {
    theme1: gold,
    theme2: landingData?.footerBgOverride || navy,
    theme3: landingData?.headerBgOverride || surface,
    theme4: slate,
    theme5: ivory,

    headerText: landingData?.headerTextOverride || navy,
    footerText: landingData?.footerTextOverride || '#E7ECF1',

    topBarBg:   '#F5F1E8',
    topBarText: navy,
  };
};
